import { FatalScreenShell } from './fatal-screen-shell';

export interface UnauthenticatedScreenProps {
	/** Where to send the user to re-authenticate. Comes from `ConnectError.signInUrl`. */
	signInUrl: string;
	/** `true` when the user's token expired (vs. missing entirely). Controls copy. */
	expired?: boolean;
	/** Back-to-launcher escape hatch. */
	onBackToLauncher?: () => void;
}

/**
 * Rendered when the kernel closes the WS with 4401 (unauthenticated) or 4410
 * (token-expired). The primary CTA is always "Sign in" — navigates to the
 * platform-signed sign-in URL.
 */
export function UnauthenticatedScreen({ signInUrl, expired, onBackToLauncher }: UnauthenticatedScreenProps) {
	const title = expired ? 'Your session has expired' : 'Please sign in to continue';
	const description = expired
		? 'Your access token has expired. Sign in again to reconnect to this workspace.'
		: 'You need to sign in before you can connect to this workspace.';

	return (
		<FatalScreenShell
			iconColor="var(--khal-accent-blue)"
			title={title}
			description={description}
			primary={{
				label: 'Sign in',
				onClick: () => {
					if (signInUrl) window.location.href = signInUrl;
				},
				testId: 'unauth-sign-in',
			}}
			secondary={
				onBackToLauncher
					? {
							label: 'Back to Launcher',
							onClick: onBackToLauncher,
							testId: 'unauth-back',
						}
					: undefined
			}
		/>
	);
}
